import type { RailLayout } from "@/data/rail-branches";
import type { LocationRun } from "../LocationRun/runs";
import { sceneStartMarkerCenterX } from "./metrics";
import { isPartLocationRun } from "../LocationRun/anchor";
import { branchIdForPartRun } from "../../rail/PartRunPhase/phase";
import { forkedBranchRailSlotX } from "../LocationRun/siteAnchor";

export function upcomingPartAnchorX(
  run: LocationRun,
  railStartMs: number,
  viewportWidth: number,
  totalDurationMs: number,
  rail?: RailLayout,
  travelerAnchorX?: number,
): number {
  if (travelerAnchorX !== undefined) {
    return travelerAnchorX;
  }
  if (rail !== undefined && isPartLocationRun(run)) {
    const branchId = branchIdForPartRun(run);
    const branch = branchId === null
      ? undefined
      : rail.branches.find((item) => item.id === branchId);
    if (branch !== undefined) {
      const forkX = forkedBranchRailSlotX(
        rail,
        branch,
        railStartMs,
        viewportWidth,
        totalDurationMs,
      );
      if (forkX !== undefined) {
        return forkX;
      }
    }
  }
  return sceneStartMarkerCenterX(railStartMs, viewportWidth, totalDurationMs);
}
